import baseTheme from "../baseTheme";

const valinorTheme = {
  ...baseTheme,
};

export default valinorTheme;
